import angular from 'angular'

import { noop, wrap } from 'lodash-es'
import { delFromArray } from '../utils/arrayh'

import idlize from '../utils/idlize'
import getSize from '../utils/get-size'
import extractRawElm from '../utils/extract-raw-elm'

import ChildResizeDetector from './child-resize-detector'

angular
  .module('ggs.line-overload')
  .factory('LineOverloadInternal', LineOverloadInternalProvider)
  .factory('LineOverload', LineOverloadProvider)

function LineOverloadInternalProvider() {
  const regs = []

  return register

  function register($elm, callback) {
    const elm = extractRawElm($elm)
    const reg = { elm, callback }

    reg.result = undefined
    reg.irecalc = idlize(wrap(reg, recalc))
    reg.destroy = wrap(reg, release)
    reg.detector = ChildResizeDetector(reg.elm, reg.irecalc)
    reg.irecalc()

    regs.push(reg)
    return reg
  }

  function release(reg) {
    reg.irecalc = noop
    reg.destroy = noop
    reg.callback = noop
    reg.detector.destroy()
    delFromArray(regs, reg)
  }

  function recalc(reg) {
    const result = isOverload(reg.elm)
    if (reg.result === result) return
    reg.result = result
    reg.callback(result)
  }

  function isOverload(elm) {
    if (elm.children.length === 0) {
      return false
    }

    let chdWidth = 0
    for (const child of elm.children) {
      const display = window.getComputedStyle(child).display
      if (display === 'none') {
        continue
      } else {
        chdWidth += getSize(child).outerWidth
      }
    }

    const elmWidth = getSize(elm).innerWidth
    const overload = chdWidth > elmWidth
    return overload
  }
}

function LineOverloadProvider(
  $rootScope,
  ApplyAsync,
  LineOverloadInternal) {

  return LineOverload

  function LineOverload($elm, callback) {
    return LineOverloadInternal($elm, ApplyAsync($rootScope, callback))
  }
}
